"use client";
import { polymorphicFactory } from "../../core/factory/polymorphic-factory.mjs";
import { Input } from "../Input/Input.mjs";
import { useInputProps } from "../Input/use-input-props.mjs";
import { jsx } from "react/jsx-runtime";
//#region packages/@mantine/core/src/components/InputBase/InputBase.tsx
const defaultProps = {
	__staticSelector: "InputBase",
	withAria: true,
	size: "sm"
};
const InputBase = polymorphicFactory((props) => {
	const { inputProps, wrapperProps, ...others } = useInputProps("InputBase", defaultProps, props);
	return /* @__PURE__ */ jsx(Input.Wrapper, {
		...wrapperProps,
		children: /* @__PURE__ */ jsx(Input, {
			...inputProps,
			...others
		})
	});
});
InputBase.classes = {
	...Input.classes,
	...Input.Wrapper.classes
};
InputBase.displayName = "@mantine/core/InputBase";
//#endregion
export { InputBase };

//# sourceMappingURL=InputBase.mjs.map